import React from 'react';
import { Link } from 'react-router-dom';
import "../introduction.css";

const experienceHighlights = (props) => {
    const currentDate = new Date();

    const currentPositions = props.data.map((job) => {
        
        return <div className='projects_highlight center flex_column'>
                <div className='prj_title'>
                    {job.position}
                </div>
                <div className='prj_icon'>
                    {job.organization}
                </div>
            </div>
        }
    )

    return (
        /*<div id='me_exp'>
            <div className='container' style={{display: "flex", flexWrap: "wrap"}}>
                <div className='center' style={{flexWrap: "wrap"}}>
                </div>
            </div>
            <div className='poster'>
                Experience
                <div className='poster_hr'/>
                <div className='poster_subheading'>
                    View my Professional exeprience and work I have done in those positions.
                </div>
            </div>
        </div>*/
        <div id='me_exp'>
            <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                <div className='poster'>
                    Experience
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        View my Professional experience and work I have done in those positions.
                    </div>
                    <div className='view_more_link'>
                        <Link className='more_link' to='experience'>View My Experiences in Detail</Link>
                    </div>
                </div>
            </div>
            <div className='poster_right center flex_column'>
                {currentPositions[0]}
                {currentPositions[1]}
            </div>
            <div className='poster_right center flex_column' style={{paddingRight: "5vh"}}>
                {currentPositions[2]}
                {currentPositions[3]}
            </div>
        </div>
    )
}

export default experienceHighlights;